module.exports = __webpack_public_path__ + "img/2.c2140e7d.png";